import React, { useEffect, useRef } from "react";
import { graphql, Link } from 'gatsby';
import Layout from "../components/layout";
import FluidImage from "../components/fluidImage";
import Seo from 'gatsby-plugin-wpgraphql-seo';

import * as styleSheet from "./droidal.module.scss"

const DroidalTemplate = (props) => {

  const droidalSrc = `https://appointments.uncommonortho.com/joplin?fpid=${encodeURIComponent(process.env.GATSBY_DROIDAL_FPID)}&parentpage=${encodeURIComponent(process.env.GATSBY_DROIDAL_PARENT_PAGE)}&division=${encodeURIComponent(process.env.GATSBY_DROIDAL_DIVISION)}&phonenumber=${encodeURIComponent(process.env.GATSBY_DROIDAL_PHONE)}`;

  const iframeRef = useRef(null);

  useEffect(() => {
    function handleMessage(event) {
      // Only accept messages from our booking iframe, served over https
      if (!iframeRef.current || event.source !== iframeRef.current.contentWindow) return;
      if (typeof event.origin !== "string" || !event.origin.startsWith("https://")) return;

      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (!data) return;

        window.dataLayer = window.dataLayer || [];

        /* REDIRECT FROM IFRAME */
        if (data.type === "navigate_parent" && data.url) {
          try {
            const u = new URL(data.url, window.location.href);
            if (u.protocol === "https:" || u.protocol === "http:") {
              window.location.replace(u.href);
            }
          } catch (err) {
            console.warn("Invalid navigate_parent url", err);
          }
          return;
        }

        // Simple event
        if (data.event && typeof data.event === "string") {
          window.dataLayer.push({
            event: data.event
          });
        }

        // Array payload events
        else if (Array.isArray(data.event)) {
          window.dataLayer.push({
            event: data.event[0],
            value: data.event[1]
          });
        }

        // Object payload events
        else if (typeof data.event === "object") {
          const key = Object.keys(data.event)[0];

          window.dataLayer.push({
            event: key,
            value: data.event[key]
          });
        }
      } catch (e) {
        console.warn("Invalid message received", e);
      }
    }

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

	const {
		data: {
			droidal,
			droidal: {
				title,
			},
			options: {
				headerSection: {
					ACFHeaderOptions: {
						mainNavigationSettings: {
							mobileNavigationLogo
						}
					}
				}

			}
		}
	} = props;

	return (
		<Layout>
			<Seo post={droidal} />
			<div className={styleSheet.top}>
				<div className={styleSheet.left}>
					<div className={styleSheet.lefttop}>
						{ mobileNavigationLogo && <Link to="/" className={styleSheet.logolink}><FluidImage image={mobileNavigationLogo} passedClass={styleSheet.logo} loading={"eager"} /></Link>}
					</div>
				</div>
				<div className={styleSheet.right}></div>
				<div className={styleSheet.center}>
					<h1 className={styleSheet.heading} dangerouslySetInnerHTML={{__html: title}}></h1>
				</div>
			</div>
			<div className={styleSheet.bottom}>
				<div className={styleSheet.iframeResponsiveContainerBooking}>
					<iframe
						id="droidal-iframe"
						ref={iframeRef}
						title="Book your next appointment"
						src={droidalSrc}
						style={{ width: "100%", border: "none", height: "1400px" }}
					></iframe>
				</div>
			</div>
		</Layout>
	);
};

export const query = graphql`query ($id: String!) {
  droidal: wpPage(id: {eq: $id}) {
    id
    title
    seo {
      title
      metaDesc
      focuskw
      metaKeywords
      metaRobotsNoindex
      metaRobotsNofollow
      opengraphTitle
      opengraphDescription
      opengraphImage {
        altText
        sourceUrl
        srcSet
      }
      twitterTitle
      twitterDescription
      twitterImage {
        altText
        sourceUrl
        srcSet
      }
      canonical
      cornerstone
      schema {
        articleType
        pageType
        raw
      }
    }
  }
  options: wp {
    headerSection {
      ACFHeaderOptions {
        mainNavigationSettings {
          mobileNavigationLogo {
            altText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 420, layout: CONSTRAINED)
              }
              publicURL
              extension
            }
          }
        }
      }
    }
  }
}
`;

export default DroidalTemplate;
